

import {
  getBeltConnectionState,
  useDeviceWebSocketStore,
  type BeltConnectionState,
  type WebSocketData,
} from '../store/deviceWebSocketStore'

export type { BeltConnectionState, WebSocketData }
export { getBeltConnectionState }

/**
 * Compatibility hook for existing device-data consumers.
 * The provider owns the single WebSocket lifecycle; the token parameter is
 * intentionally retained so current callers do not need to change.
 */
export function useDeviceWebSocket(_token?: string | null): WebSocketData {
  return useDeviceWebSocketStore()
}

